import getImgixUrl from "./getImgixUrl.js";
const getImgxUrl = getImgixUrl;
const src_getImgxUrl = getImgxUrl;
export default src_getImgxUrl;
